import {
  adjustmentSessionIdFormat,
  locationIdFormat,
  productIdFormat,
} from "@redotech/redo-model/ids";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

import { AdjustmentSessionKind } from "@redotech/redo-prisma-client/enums";

const AdjustmentSessionProductSchema_ = z.object({
  productId: productIdFormat.schema,
  quantity: z.number(),
});

export const AdjustmentSessionProductSchema: z.ZodType<AdjustmentSessionProductSchema> =
  AdjustmentSessionProductSchema_;
export interface AdjustmentSessionProductSchema
  extends z.infer<typeof AdjustmentSessionProductSchema_> {}

const AdjustmentSessionSchema_ = z.object({
  id: adjustmentSessionIdFormat.schema,
  accountId: zExt.objectId(),
  locationId: locationIdFormat.schema,
  legacyUserId: z.string(),
  kind: z.enum(AdjustmentSessionKind),
  sourceId: z.string().nullable(),
  status: z.enum(["in_progress", "completed", "cancelled", "reversed"]),
  createdAt: z.string(),
  updatedAt: z.string(),
  submittedAt: z.string().nullable(),
  deletedAt: z.string().nullable(),
});

export const AdjustmentSessionSchema: z.ZodType<AdjustmentSession> =
  AdjustmentSessionSchema_;
export interface AdjustmentSession
  extends z.infer<typeof AdjustmentSessionSchema_> {}

export const createAdjustmentSession = {
  name: "createAdjustmentSession" as const,
  input: z.object({
    locationId: locationIdFormat.schema,
    kind: z.enum(AdjustmentSessionKind),
    sourceId: z.string(),
  }),
  output: z.object({ session: AdjustmentSessionSchema }),
};

export { AdjustmentSessionKind } from "@redotech/redo-prisma-client/enums";
